// HomePage.js
import React from 'react';

import HeroSection from './HeroSection';
import WhatDoWeOffer from './WhatDoWeOffer';
import MeetOurTeam from './MeetOurTeam';
import Courses from './Courses';
import Collaborators from './Collaborators';
import CompanyShowcase from './CompanyShowcase';
import HiringPartners from './HiringPartners';
import AwardsRecognization from './AwardsRecognization';
import AwardsGallery from './AwardsGallery';
import SuccessStories from './SuccessStories';
import Testimonials from './Testimonials';
import WhyCompaniesPrefer from './WhyCompaniesPrefer';
import MentorCommunity from './MentorCommunity';
import AssociatedWith from './AssociatedWith';
import Footer from './Footer';

export default function HomePage({ setIsEnrollOpen }) {
  const openEnroll = () => setIsEnrollOpen(true);

  return (
    <>
      <HeroSection openEnroll={openEnroll} />
      <WhatDoWeOffer id="what-we-offer" />
      <MeetOurTeam />
      <AwardsGallery />
      <AwardsRecognization />
      <Courses openEnroll={openEnroll} />
      <Collaborators />
      <Testimonials id="testimonials" />
      <CompanyShowcase />
      <MentorCommunity id="mentor-community" />
      <HiringPartners setIsEnrollOpen={setIsEnrollOpen} />
      <SuccessStories />
      <WhyCompaniesPrefer />
      <AssociatedWith />
      <Footer openEnroll={openEnroll} />
    </>
  );
}
